import axios from 'axios';

const bff = axios.create({
  // baseURL: 'https://bff.tempedido.com',
  // baseURL: 'http://localhost:3333',
  baseURL: process.env.REACT_APP_API_URL,
});

export { bff };
